"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelQueryRunRpcResponseImplementation = exports.CancelQueryRunRpcRequestImplementation = void 0;
const core_1 = require("./core");
class CancelQueryRunRpcRequestImplementation extends core_1.BaseRpcRequest {
    constructor() {
        super(...arguments);
        this.method = "cancelQueryRun";
    }
}
exports.CancelQueryRunRpcRequestImplementation = CancelQueryRunRpcRequestImplementation;
class CancelQueryRunRpcResponseImplementation extends core_1.BaseRpcResponse {
}
exports.CancelQueryRunRpcResponseImplementation = CancelQueryRunRpcResponseImplementation;
//# sourceMappingURL=cancel-query-run.type.js.map